@@ -0,0 +1,457 @@
<template>
    <div id="datatable">
        <v-data-table
            single-select
            :headers="headers"
            :items="currentPageItems"
            :page.sync="currentPage"
            :items-per-page="customPaginationPerPage"
            item-key="no"
            hide-default-footer
            :class="$attrs.customWidth ? 'width_control' : ''"
            :loading="tableLoading"
            loading-text="Memuat data..."
            @dblclick:row="selectRowAndFinish"
            @click:row="rowClick"
            height="auto"
        >
            <template v-if="$scopedSlots['no-data']" v-slot:no-data>
                <slot name="no-data"></slot>
            </template>

            <template v-slot:top>
                <v-card-text class="py-0">
                    <v-container fluid>
                        <v-row class="my-3">
                            <v-col cols="*">
                                <!-- Search input by all headers key -->
                                <v-text-field
                                    id="datatable_search"
                                    v-model="query"
                                    outlined
                                    height="36px"
                                    hide-details
                                    class="search_box"
                                    @keyup.enter="doBasicFilter()"
                                    placeholder="Ketik kata kunci dan tekan enter"
                                >
                                    <template slot="prepend-inner">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                                fill="#073554"
                                            />
                                            <path
                                                d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                                fill="#073554"
                                            />
                                        </svg>
                                    </template>
                                </v-text-field>
                            </v-col>

                            <!-- Sort by id feature -->
                            <!-- <v-col cols="2">
                                <v-select
                                    id="datatable_sort"
                                    :disabled="
                                        $route.name === 'ItemBank' ||
                                        $route.name === 'Transaksi' ||
                                        $route.name === 'Leaderboard'
                                    "
                                    v-if="$route.name != 'UserGroupForm'"
                                    v-model="orderBy"
                                    height="36px"
                                    hide-details
                                    placeholder="Urutkan"
                                    class="select_box"
                                    outlined
                                    :items="[
                                        { text: 'Baru ke Lama', value: 'desc' },
                                        { text: 'Lama ke Baru', value: 'asc' },
                                    ]"
                                    item-text="text"
                                    item-value="value"
                                    @change="updateOrderBy"
                                ></v-select>
                            </v-col> -->
                        </v-row>
                    </v-container>
                </v-card-text>
            </template>

            <!-- If headers have label item, trim the text-->
            <template v-slot:[`item.label`]="{ item }">
                <span>{{
                    item.label ? item.label.replace(/ /g, "&nbsp;") : item.label
                }}</span>
            </template>

            <template v-slot:[`item.picture`]="{ item }">
                <div class="py-3">
                    <img
                        :src="item.picture"
                        width="100%"
                        style="border-radius: 5px"
                    />
                </div>
            </template>

            <!-- Regenerate no by index, because no used for redirect to detail -->
            <template v-slot:[`item.no`]="{ index }">
                {{
                    (customPaginationPerPage || 10) * (currentPage - 1) +
                    (index + 1)
                }}
            </template>

            <!-- If headers have is_restricted item, change to icon checkbox -->
            <template v-slot:[`item.is_restricted`]="{ item }">
                <v-icon v-if="!item.is_restricted" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <!-- If headers have is_home item, change to icon checkbox -->
            <template v-slot:[`item.is_home`]="{ item }">
                <v-icon v-if="!item.is_home" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <!-- If headers have is_live_class item, change to icon checkbox -->
            <template v-slot:[`item.is_live_class`]="{ item }">
                <v-icon v-if="!item.is_live_class" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <template v-slot:[`item.is_specific`]="{ item }">
                <div v-if="item.is_specific != null">
                    <v-icon v-if="item.is_specific" color="green3"
                        >mdi-checkbox-marked</v-icon
                    >
                    <v-icon v-else color="darkFade">mdi-close-box</v-icon>
                </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <v-btn
                    v-if="item.status === 'PUBLISHED'"
                    small
                    depressed
                    rounded
                    color="#EEFFE0"
                    style="color: #40bf75"
                >
                    Publikasi
                </v-btn>

                <v-btn
                    v-if="item.status === 'DRAFT'"
                    small
                    depressed
                    rounded
                    color="#FFF3E0"
                    style="color: orange"
                >
                    Draft
                </v-btn>

                <v-btn
                    v-if="item.status === 'REVIEW'"
                    small
                    depressed
                    rounded
                    color="#E8F5FA"
                    style="color: #2690cb"
                >
                    Review
                </v-btn>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <v-btn
                    v-if="item.status === 'TO_DO'"
                    small
                    depressed
                    rounded
                    color="#EB3123"
                    style="color: #ffffff"
                >
                    To Do
                </v-btn>

                <v-btn
                    v-if="item.status === 'DONE'"
                    small
                    depressed
                    rounded
                    color="#BCF8CC"
                    style="color: #00cf3f"
                >
                    Done
                </v-btn>

                <v-btn
                    v-if="item.status === 'IN_PROGRESS'"
                    small
                    depressed
                    rounded
                    color="#E1F4FC"
                    style="color: #0e97d6"
                >
                    In Progress
                </v-btn>

                <v-btn
                    v-if="item.status === 'PUBLISHED'"
                    small
                    depressed
                    rounded
                    color="#EEFFE0"
                    style="color: #40bf75"
                >
                    Publikasi
                </v-btn>

                <v-btn
                    v-if="item.status === 'DRAFT'"
                    small
                    depressed
                    rounded
                    color="#FFF3E0"
                    style="color: orange"
                >
                    Draft
                </v-btn>

                <v-btn
                    v-if="item.status === 'REVIEW'"
                    small
                    depressed
                    rounded
                    color="#E8F5FA"
                    style="color: #2690cb"
                >
                    Review
                </v-btn>
            </template>

            <!-- If headers have actions item, show headers aksi -->
            <!-- <template
                v-slot:[`item.actions`]="{ item }"
                v-if="
                    $route.name === 'ModulPembelajaranReport' ||
                    $route.name === 'VdPembelajaranReport'
                "
            >
                <a
                    @click="selectRowAndFinish(item.no)"
                    style="
                        color: #0e97d6;
                        text-decoration: underline;
                        cursor: pointer;
                    "
                >
                    Lihat Detail
                </a>
            </template> -->

            <template v-slot:[`item.actions`]="{ item }">
                <a
                    v-if="
                        $route.name === 'ModulPembelajaranReport' ||
                        $route.name === 'VdPembelajaranReport'
                    "
                    @click="selectRowAndFinish(item.no)"
                    style="
                        color: #0e97d6;
                        text-decoration: underline;
                        cursor: pointer;
                    "
                >
                    Lihat Detail
                </a>
                <!-- Default if hasAction true, change to icon vertical three dots -->
                <v-menu offset-y v-if="hasAction">
                    <template
                        v-slot:activator="{ on, attrs }"
                        v-if="
                            $route.name === 'ModulPembelajaran' ||
                            $route.name === 'VideoPembelajaran'
                        "
                    >
                        <div icon v-bind="attrs" v-on="on">
                            <v-icon color="#4F4F4F" id="datatable_dot_btn"
                                >mdi-dots-vertical</v-icon
                            >
                        </div>
                    </template>

                    <v-list>
                        <!-- Default detail if doesn't have hasPreviewSoal -->
                        <v-list-item
                            id="datatable_detail_btn"
                            class="test_cursor"
                            link
                            v-if="hasEdit"
                            @click="updateItem(item.no)"
                        >
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="datatable_detail_btn"
                            class="test_cursor"
                            link
                            @click="selectRowAndFinish(item.no)"
                        >
                            <v-list-item-title>Detail</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            class="test_cursor"
                            link
                            @click="duplicateItem(item.no)"
                        >
                            <v-list-item-title>Duplikat</v-list-item-title>
                        </v-list-item>

                        <!-- Delete button -->
                        <v-list-item
                            class="test_cursor"
                            v-if="$route.name != 'AmbisMeter'"
                            id="datatable_delete_btn"
                            link
                            @click="deleteItem(item.no)"
                        >
                            <v-list-item-title>Hapus</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <!-- If hasActionn false && hasDuplicate true, change to icon vertical three dots with Duplicate & Export Button -->
                <v-menu offset-y v-if="hasDuplicate">
                    <template v-slot:activator="{ on, attrs }">
                        <div icon v-bind="attrs" v-on="on">
                            <v-icon color="#4F4F4F" id="datatable_dot_btn">
                                mdi-dots-vertical
                            </v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-item
                            id="datatable_duplicate_btn"
                            class="test_cursor"
                            link
                            @click="duplicateItem(item.no)"
                        >
                            <v-list-item-title>Duplicate</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>

        <!-- Default pagination if hasCustomPagination 0, shown total item '-' -->
        <div
            class="d-flex space-between pa-4"
            v-if="hasCustomPagination && customPaginationTotalPages === 0"
        >
            <span class="gray3--text">
                Menampilkan {{ items.length * currentPage }} dari -
            </span>
            <v-spacer />

            <!-- Pagination preview button -->
            <v-btn
                depressed
                class="pa-0"
                :disabled="currentPage == 1"
                @click="goToPage(--currentPage)"
                min-width="32px"
                height="32px"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <!-- Pagination current page -->
            <v-btn
                class="pa-0 mx-2"
                depressed
                dark
                color="blew"
                min-width="32px"
                height="32px"
            >
                {{ currentPage }}
            </v-btn>

            <!-- Pagination next button -->
            <v-btn
                depressed
                class="pa-0"
                min-width="32px"
                height="32px"
                :disabled="items.length < customPaginationPerPage"
                @click="goToPage(++currentPage)"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>

        <!-- If hasCustomPagination not 0, shown customPaginationTotalPages -->
        <div class="d-flex align-center space-between pa-4" v-else>
            <span class="gray3--text">
                Menampilkan
                {{ customPaginationPerPage * (currentPage - 1) + 1 }}
                sampai
                {{
                    customPaginationPerPage * currentPage > items.length
                        ? customPaginationTotalItems
                            ? customPaginationTotalItems
                            : customPaginationPerPage * (currentPage - 1) +
                              items.length
                        : customPaginationPerPage * currentPage
                }}
                dari
                {{
                    customPaginationTotalItems
                        ? customPaginationTotalItems + " entri"
                        : ` -`
                }}
            </span>
            <v-spacer />

            <!-- Pagination current page -->
            <v-pagination
                color="blew"
                @input="currentPage"
                v-model="currentPage"
                :length="maxPage"
                :total-visible="7"
            ></v-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "datatable",

    props: {
        items: { type: Array, default: [] },
        headers: { type: Array, default: [] },
        hasAction: { type: Boolean, default: false },
        hasDetail: { type: Boolean, default: false },
        hasExport: { type: Boolean, default: false },
        hasPreview: { type: Boolean, default: false },
        hasMultiSearch: { type: Boolean, default: false },
        hasPreviewSoal: { type: Boolean, default: false },
        hasPublish: { type: Boolean, default: false },
        hasDownload: { type: Boolean, default: false },
        hasPaymentStatus: { type: Boolean, default: false },
        hasOpenNewTab: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        // Diteruskan ke v-data-table; terpisah dari `loading` yang memicu re-order
        tableLoading: { type: Boolean, default: false },
        hasReview: { type: Boolean, default: false },
        hasCustomPagination: { type: Boolean, default: false },
        hasCustomSearch: { type: Boolean, default: false },
        hasDuplicate: { type: Boolean, default: false },
        hasEdit: { type: Boolean, default: false },
        persistFilter: { type: Boolean, default: true },
        currentPageProp: { type: Number, default: 1 },
        customPaginationCurrentPage: { type: Number, default: 1 },
        customPaginationPerPage: { type: Number, default: 0 },
        customPaginationTotalItems: { type: Number, default: 0 },
        customPaginationTotalPages: { type: Number, default: 0 },
        customPaginationSortMode: { type: String, default: "desc" },
    },

    data: function () {
        return {
            currentPageItems: [],
            selectedRow: -1,
            filteredItems: [],
            headerKeys: [],
            query: null,
            orderBy: "desc",
            sorter: { text: "Baru ke Lama", value: true },
            field: 0,
            videoId: null,
            visibleRow: { text: "Row : 10", value: 10 },
        };
    },

    computed: {
        // not used
        player() {
            return this.$refs.youtube.player;
        },

        // set currentPage, if changed trigger goToPage to change data shown
        currentPage: {
            get: function () {
                if (this.hasCustomPagination) {
                    return this.customPaginationCurrentPage;
                }

                return parseInt(this.$store.state.datatable.currentPage);
            },

            set: function (val) {
                if (this.hasCustomPagination) {
                    this.goToPage(val);
                } else {
                    this.$store.commit("datatable_currentPage", val);
                }
            },
        },

        // not used
        pageStart: function () {
            return this.$store.state.datatable.pageStart;
        },

        // set pageSize, trigger data shown in one page
        pageSize: {
            get: function () {
                return (
                    this.customPaginationPerPage ||
                    this.$store.state.datatable.pageSize
                );
            },

            set: function (val) {
                this.currentPageItems = this.getItemsInPage(this.currentPage);
                this.customPaginationPerPage = val;
            },
        },

        // not used
        pageEnd: function () {
            return this.$store.state.datatable.pageEnd;
        },

        // set maxPage, if hasCustomPagination true set customPaginationTotalPages
        maxPage: function () {
            return this.hasCustomPagination
                ? this.customPaginationTotalPages
                    ? this.customPaginationTotalPages
                    : Math.ceil(this.customPaginationTotalItems / this.pageSize)
                : Math.ceil(this.filteredItems.length / this.pageSize);
        },

        // not used
        startNumber() {
            if (this.$route.name === "ItemBank") {
                return (this.currentPageProp - 1) * this.pageSize;
            } else {
                return (this.currentPage - 1) * this.pageSize;
            }
        },

        // not used
        filterCriteria: function () {
            var result = [];
            var filters = [];
            if (this.persistFilter)
                filters = this.$store.state.datatable.filters;

            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                var criteria = this.headers[filter.key] + " = " + filter.value;
                result.push(criteria);
            }

            return result;
        },
    },

    methods: {
        // Change sort by id
        updateOrderBy: function (order) {
            if (order) {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", order);
                else this.doOrder();
            } else {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", order);
                else this.doOrder();
            }
        },

        // Change data shown
        goToPage: function (page) {
            this.$emit("changePage", page);
        },

        // set pageSize, trigger data shown in one page
        getItemsInPage: function (page) {
            page = this.hasCustomPagination ? 1 : page;
            var start = (page - 1) * this.pageSize;
            var end = start + this.pageSize;

            if (end > this.filteredItems.length - 1) {
                return this.filteredItems.slice(start);
            }

            return this.filteredItems.slice(start, end);
        },

        // notify deleted data by givev no data (index = no data)
        deleteItem: function (index) {
            var selectedRow = this.selectRow(index);
            this.$emit("deleted", selectedRow);
        },

        // give detail data choosen by no data
        selectRow: function (index) {
            var realIndex = index;
            this.selectedRow = index;

            var selectedRow = this.filteredItems.find(function (element) {
                return element.no == realIndex;
            });
            this.$emit("selected", selectedRow);

            return selectedRow;
        },

        // given no data to selectRow, and notify detail data to dblClicked
        selectRowAndFinish(index, data = null) {
            var selectedRow = this.selectRow(index);
            if (data) {
                selectedRow = this.selectRow(data.item.no);
            }
            this.$emit("dblClicked", selectedRow);
        },

        // notify duplicateClicked with detail data by no data (index = no data)
        duplicateItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("duplicateClicked", selectedRow);
        },

        // open in new tab detail
        openNewTab(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("openNewTab", selectedRow);
        },

        // notify editNewTab with detail data by no data (index = no data)
        editItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("editNewTab", selectedRow);
        },

        updateItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("updateItem", selectedRow);
        },

        // notify previewSoal with detail data by no data (index = no data)
        previewItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("previewSoal", selectedRow);
        },

        // search manually with all data given (just work with data not pagination)
        doBasicFilter: function () {
            this.currentPage = 1;
            this.$emit("doSearch", this.query);
        },

        // order all data given by id data
        doOrder: function () {
            var tmp = this.filteredItems.slice(0);
            this.filteredItems = [];
            if (this.orderBy == "asc") {
                tmp.sort(function (a, b) {
                    return a.id - b.id;
                });
            } else {
                tmp.sort(function (a, b) {
                    return b.id - a.id;
                });
            }

            this.filteredItems = tmp;
        },

        rowClick: function (item, row) {
            row.select(true);
        },
    },

    watch: {
        //not used
        // if currentPage changed trigger getItemsInPage to make sure data shown not max with pageSize (not used)
        currentPage: function (page) {
            this.currentPageItems = this.getItemsInPage(page);
        },

        // not used
        loading: function () {
            if (!this.loading) {
                setTimeout(() => {
                    this.updateOrderBy(this.orderBy);
                    this.doOrder();
                }, 500);
            }
        },

        // put all data items to filteredItems
        items: function (val) {
            this.filteredItems = val;
            var filters = this.$store.state.datatable.filter;
            if (filters.length > 0) {
                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    this.doBasicFilter(filter);
                }
            } else {
                this.doOrder();
            }
        },

        // not used
        filteredItems: function (val) {
            this.$store.commit("datatable_currentPage", 1);
            this.currentPageItems = this.getItemsInPage(this.currentPage);
        },

        // put value orderBy on this.sorter.value if orderBy changed
        orderBy: function (val) {
            if (val == "desc") {
                this.sorter.value = true;
            } else {
                this.sorter.value = false;
            }
            this.$store.commit("datatable_orderby", val);
        },

        // trigger updateOrderBy if sorter changed
        sorter: function (val) {
            this.updateOrderBy();
        },
    },

    mounted: function () {
        // make sure filter do not overlap when moving page
        this.$store.commit("datatable_clear_filter");
        this.$store.commit("datatable_clear_filters");
        this.filteredItems = this.items;
        this.currentPageItems = this.getItemsInPage(1);

        // regenerate headerKeys to remove actions
        this.headers.forEach((element, index) => {
            if (element.value != "actions" && element.value !== "picture")
                this.headerKeys.push(element);
        });

        //
        if (this.hasCustomPagination)
            this.orderBy = this.customPaginationSortMode;
        else this.orderBy = this.$store.state.datatable.orderBy;

        setTimeout(() => {
            // waiting this.filteredItems = this.items; so can order with filteredItems
            this.doOrder();
        }, 500);

        // make sure filter do not overlap when moving page
        if (this.$store.state.datatable.filter != {}) {
            (this.query = this.$store.state.datatable.filter.value),
                (this.field = this.$store.state.datatable.filter.key);
        }
    },
};
</script>

<style scoped>
.v-data-table >>> tr.v-data-table__selected {
    background: #bbdefb !important;
}

.search_box >>> .v-input__slot {
    min-height: 40px !important;
    padding: 0px !important;
}

.search_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.v-text-field--outlined >>> fieldset {
    border: 0 !important;
}

.search_box >>> .v-input__append-inner {
    margin: 0px !important;
}

.select_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.inside_search >>> .v-input__slot {
    padding-right: 12px !important;
    padding-left: 12px !important;
}

.inside_search >>> .v-input__control {
    background: #fbfbfb !important;
}

.inside_search >>> .v-input__append-inner {
    margin-bottom: 6px !important;
    margin-top: 6px !important;
}

.inside_search >>> .v-input {
    margin: 0px !important;
}

.width_control >>> td {
    max-width: 400px !important;
}

.normal .v-select.v-text-field input {
    min-width: 0 !important;
}

.search_box >>> .v-input__prepend-inner {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.v-input__slot {
    min-height: 40px !important;
    font-size: 14px !important;
}

.select_box >>> .v-input__control > .v-input__slot {
    min-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// DataTableModule.vue?659d2c9c